import { InjectionToken } from '@angular/core';

/**
 * Public Forms SPA origin (no trailing slash) for order-follow QR links on printed tickets.
 * Provide per app (e.g. Agent `environment.formsPublicBaseUrl`, Forms `environment.formsPublicBaseUrl`).
 */
export const ORDER_TICKET_PUBLIC_FORMS_ORIGIN = new InjectionToken<string>(
  'ORDER_TICKET_PUBLIC_FORMS_ORIGIN',
  {
    factory: () => '',
  },
);
